import { Dialog, Modal } from "react-aria-components";
import { Dropdown } from "src/components/Dropdown/Dropdown";
import { tw } from "src/design-system/tw";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";

export default function DatePopout({
  children,
  label,
  isOpen = false,
  anchor = "left",
  className,
}: {
  label: string;
  children: React.ReactNode;
  isOpen?: boolean;
  anchor?: "left" | "right" | "center";
  className?: string;
}) {
  const { isMdScreen } = useScreenMinWidth();

  if (isMdScreen) {
    return (
      <Dropdown
        role="dialog"
        anchor={anchor}
        className={tw("top-10 mt-2 h-auto w-[670px] p-3", className)}
        borderRadius="rounded_xl"
        aria-label={label}
        isOpen={isOpen}
      >
        {children}
      </Dropdown>
    );
  }

  return (
    <Modal
      className="fixed top-0 left-0 z-[100002] flex min-h-screen w-lvw flex-col items-center overflow-auto bg-white pb-20 transition-all duration-300 ease-in-out"
      aria-label={label}
      isOpen={isOpen}
    >
      <Dialog aria-label={label} className="max-h-screen overflow-auto pb-20">
        {children}
      </Dialog>
    </Modal>
  );
}
